import { PlusOutlined } from '@ant-design/icons';
import { PropsWithChildren } from 'react';

import { ChildConditionType } from '@invenco/common-domain/enums';

import { Button } from '@/components-ant/button';
import { childConditionTypeTitle } from '@/shared/title-maps';

type Props = {
  conditionType?: ChildConditionType;
  onClick: () => void;
};

export function AddButton({ conditionType, onClick, children }: PropsWithChildren<Props>) {
  return (
    <Button type="link" inline icon={<PlusOutlined />} size="small" onClick={onClick}>
      {conditionType ? `${childConditionTypeTitle[conditionType]} Condition` : children}
    </Button>
  );
}
